module.exports = __webpack_public_path__ + "assets/img/btn-view-all-hover-f2b328e7.png";